import {
  useCallback,
  useEffect,
  useState,
} from "react";

import {
  fetchActiveFinancingScenarios,
} from "../../services/riskFinancingApi";

export default function useActiveFairScenarios({
  enabled = false,
} = {}) {
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadScenarios = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const data =
        await fetchActiveFinancingScenarios();

      setScenarios(
        Array.isArray(data) ? data : []
      );
    } catch (requestError) {
      console.error(
        "Active FAIR scenarios error:",
        requestError
      );

      setError(requestError);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;

    loadScenarios();
  }, [enabled, loadScenarios]);

  return {
    scenarios,
    loading,
    error,
    refresh: loadScenarios,
  };
}